// extracted by mini-css-extract-plugin
module.exports = {"titleblock":"titleblock_titleblock__rR8V4","titletext":"titleblock_titletext__2ZU_P","titlelead":"titleblock_titlelead__32wUS","morelink":"titleblock_morelink__6gY1t"};